import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../index';
import { AdviserDetails } from '../../type-definitions/redux-declarations';

export type InjectedProps = AdviserDetails;

const withAdviserState = <P extends InjectedProps>(
	Component: React.ComponentType<P>
) => {
	class HOC extends React.Component<P> {
		render() {
			return <Component {...(this.props as P)} />;
		}
	}

	const mapStateToProps = ({ adviser }: AppState): AdviserDetails => {
		return adviser.adviserDetails;
	};

	//@ts-ignore
	return connect<P, any, any>(mapStateToProps)(HOC as any);
};

export default withAdviserState;
